var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1608_326463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9507 14.9497C13.5261 16.0355 11.7916 16.6371 10.0007 16.6663C4.16732 16.6663 0.833984 9.99967 0.833984 9.99967C1.87056 8.06792 3.30826 6.38018 5.05065 5.04967M8.25065 3.53301C8.82426 3.39874 9.41154 3.33162 10.0007 3.33301C15.834 3.33301 19.1673 9.99967 19.1673 9.99967C18.6615 10.946 18.0582 11.837 17.3673 12.658M11.7673 11.7663C11.5384 12.012 11.2624 12.209 10.9558 12.3456C10.6491 12.4822 10.3181 12.5557 9.98239 12.5616C9.64672 12.5676 9.31329 12.5058 9.00199 12.3801C8.6907 12.2543 8.40792 12.0672 8.17052 11.8298C7.93313 11.5924 7.74598 11.3096 7.62024 10.9983C7.4945 10.687 7.43276 10.3536 7.43868 10.0179C7.4446 9.68226 7.51807 9.35121 7.65471 9.04455C7.79135 8.73788 7.98836 8.46188 8.23398 8.23301M0.833984 0.833008L19.1673 19.1663",
    stroke: "#90A8C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1608_326463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOff.8ac0f485a7dcaa0e81c18664df0a7538.svg";
export { ForwardRef as ReactComponent };